class LoginDrawer extends DrawerComponent {
    constructor() {
        super();

        this.querySelector('#OpenRecoverFromLogin')?.addEventListener('click', (e) => {
            this.hide();
        });

        this.querySelector('#OpenRegisterFromLogin')?.addEventListener('click', (e) => {
            this.hide();
        });

        this.querySelector('#loginForm')?.addEventListener('click', (e) => {
            const email = document.querySelector('#LoginDrawer input[name="customer[email]"]')?.value.trim();
            const password = document.querySelector('#LoginDrawer input[name="customer[password]"]')?.value.trim();

            const messageEmail = document.querySelector('#LoginDrawer #login-error-email');
            const messagePassword = document.querySelector('#LoginDrawer #login-error-password');

            let hasError = false;

            const showError = (element, message, inputElement) => {
                element.classList.remove('hidden');
                element.innerText = message;
                inputElement.classList.add('has-error');
                hasError = true;
            };

            const hideError = (element, inputElement) => {
                element.classList.add('hidden');
                element.innerText = '';
                inputElement.classList.remove('has-error');
            };

            // Validate email
            const emailInput = document.querySelector('#LoginDrawer input[name="customer[email]"]');
            if (!email) {
                showError(messageEmail, 'This is a required field.', emailInput);
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                showError(messageEmail, 'Please enter a valid email address.', emailInput);
            } else {
                hideError(messageEmail, emailInput);
            }

            // Validate password
            const passwordInput = document.querySelector('#LoginDrawer input[name="customer[password]"]');
            if (!password) {
                showError(messagePassword, 'This is a required field.', passwordInput);
            } else {
                hideError(messagePassword, passwordInput);
            }

            if (hasError) e.preventDefault();
        });
    }
}

if (!customElements.get('login-drawer')) {
    customElements.define('login-drawer', LoginDrawer);
}